var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"},attrs:{"v-show":_vm.path}},[_vm._v("We could not take payment at this time...")])}
var staticRenderFns = []

export { render, staticRenderFns }